export default __webpack_public_path__ + "static/media/v6.5bd17e05.svg";